import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/**
 * Precomputed counts of graded characters that use a grapheme as a decomposition component.
 *
 * These counts are scoped to the same grading sets used by the browse primitives page: HSK 2.0,
 * HSK 3.0, HSK 3.1, and TBCL. They count eligible compound graphemes only; the actual compound
 * glyph lists remain derived from `grapheme_component`.
 */
export const graphemeCompoundsDataTable = staticTable(
  "grapheme_compounds_data",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    hsk2010CompoundsCount: integer("hsk_2010_compounds_count").notNull(),
    hsk2021CompoundsCount: integer("hsk_2021_compounds_count").notNull(),
    hsk2026CompoundsCount: integer("hsk_2026_compounds_count").notNull(),
    tbclCompoundsCount: integer("tbcl_compounds_count").notNull(),
  },
  (table) => [index("grapheme_compounds_data_grapheme_id_idx").on(table.graphemeId)],
);

export type GraphemeCompoundsData = typeof graphemeCompoundsDataTable.$inferSelect;
